module.exports = __webpack_public_path__ + "img/newsImg11-31.f47e270c.png";